<template>
  <div class="register">
    <div class="register-left"></div>
    <div class="register-right">
        <div class="logo">
          <img src="../../assets/images/account/logo.png" alt="">
        </div>
        <a-form class="form" :form="form">
          <a-modal
            class="rule-layer"
            :bodyStyle="{
              height: '700px',
              'overflow-y': 'scroll'
            }"
            :maskClosable='false'
            title="e企测注册协议及服务条款"
            :visible="visible"
            @cancel="handleCancel"
            :footer="null"
            width="800px"
            >
            e企测服务（以下简称“本服务”）是由 浙江宏恩网络科技有限公司（以下简称“本公司”）向e企测用户提供的关于管理认证证书和报告相关服务。本协议由您和本公司签订。<br>
            <p style="font-size:18px;weight:bold">一、总则</p>
            (一)您确认：在您注册成为e企测用户并接受本服务之前，您已充分阅读、理解并接受本协议的全部内容，一旦您选择“同意”并完成注册进行购买或使用本服务，即表示您同意遵循本协议之所有约定。<br>
            (二)您同意，本公司有权随时对本协议内容进行单方面的变更，并以在本网站公告的方式予以公布，无需另行单独通知您；若您在本协议内容公告变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的协议内容使用本服务；若您不同意修改后的协议内容，您应停止使用本服务。<br>
            (三)您声明，在您同意接受本协议并注册成为e企测用户时，您是具有法律规定的完全民事权利能力和民事行为能力，能够独立承担民事责任的自然人、法人或其他组织；本协议内容不受您所属国家或地区法律的排斥。不具备前述条件的，您应立即终止注册或停止使用本服务。<br>
            <p style="font-size:18px;weight:bold">二、本服务简介</p>
            向注册用户提供体系咨询认证和资质认证及其相关服务。本协议由您和本公司签订。<br>
            及其相关服务，e企测所提供的相关服务说明详见网址： www. Spideweb. cn相关产品及服务介绍。<br>
            <p style="font-size:18px;weight:bold">三、e企测账户</p>
            (一)注册相关<br>
            在使用本服务前，您必须先行注册，取得本公司提供给您的e企测账户（以下简称“该账户”），您同意并保证您所填写的用户信息是真实、准确、完整、及时的，并且没有任何引人误解或者虚假的陈述，且保证e企测可以通过您所填写的联系方式与您取得联系。您应根据e企测对于相关服务的要求及时提供相应的身份证明等资料，否则e企测有权拒绝向您提供相关服务。您承诺将及时更新您用户信息以维持该等信息的有效性。如果您提供的资料或信息包含有不正确、不真实的信息，e企测保留取消您会员资格并随时结束为您提供服务的权利<br>
            (二)账户安全<br>
            您将对使用该账户及密码进行的一切操作及言论负完全的责任，您同意：本公司通过您的用户名和密码识别您的指示，请您妥善保管您的用户名和密码，对于因密码泄露所致的损失，由您自行承担。您保证不向其他任何人泄露该账户及密码，亦不使用其他任何人的e企测账户及密码。您发现有他人冒用或盗用您的账户及密码或任何其他未经合法授权之情形时，应立即以有效方式通知本公司，要求本公司暂停相关服务。同时，您理解本公司对您的请求采取行动需要合理期限，在此之前，本公司对已执行的指令及(或)所导致的您的损失不承担任何责任。<br>
            <p style="font-size:18px;weight:bold">四、e企测服务使用守则</p>
            为有效保障您使用本服务的合法权益，您理解并同意接受以下规则：<br>
            (一)您在使用本服务过程中，本协议内容、网页上出现的关于相关操作的提示或本公司发送到您手机的信息（短信或电话等）内容是您使用本服务的相关规则，您使用本服务即表示您同意接受本服务的相关规则。您了解并同意本公司单方修改服务的相关规则，而无须征得您的同意，服务规则应以您使用服务时的页面提示（或发送到该手机的短信或电话等）为准，您同意并遵照服务规则是您使用本服务的前提。<br>
            (二)本公司可能会以电子邮件（或发送到您手机的短信或电话等）方式通知您服务进展情况以及提示您进行下一步的操作，但本公司不保证您能够收到或者及时收到该邮件（或发送到该手机的短信或电话等），且不对此承担任何后果。因此，在服务过程中您应当及时登录到本网站查看和进行相关操作。因您没有及时查看和对服务状态进行修改或确认或未能提交相关申请而导致的任何纠纷或损失，本公司不负任何责任。<br>
            (三)服务费用，在您使用本服务时，本公司有权依照相应的服务收费介绍、订单及/或相关协议向您收取服务费用。本公司拥有制订及调整服务费之权利，具体服务费用以您使用本服务时本网站上所列之收费方式公告或您与本公司达成的其他书面协议为准。<br>
            <p style="font-size:18px;weight:bold">五、您的权利和义务</p>
            (一)您有权利拥有自己在e企测的用户名和密码并有权利使用自己的用户名和密码随时登录e企测。<br>
            (二)您有权利享受e企测提供的知识产权法律及其相关服务，并有权利在接受e企测提供的服务时获得e企测的支持、咨询等服务，服务内容详见e企测相关产品介绍。<br>
            (三)您保证不会利用技术或其他手段破坏及扰乱e企测和服务以及e企测其他客户的网站和服务<br>
            (四)您应尊重e企测及其他第三方的知识产权和其他合法权利，并保证在发生侵犯上述权益的违法事件时尽力保护e企测及其股东、雇员、合作伙伴等免于因该等事件受到影响或损失；e企测保留您侵犯e企测合法权益时终止向您提供服务的权利。<br>
            (五)对由于您向e企测提供的联络方式有误以及您用于接受e企测邮件的电子邮箱安全性、稳定性不佳而导致的一切后果，您应自行承担责任，包括但不限于因您未能及时收到e企测的相关通知而导致的后果和损失。<br>
            (六)您保证您使用e企测服务时将遵从国家、地方法律法规、行业惯例和社会公共道德，不会利用e企测提供的服务进行违反国家法律法规政策的信息。您承认e企测有权在您违反上述约定时有权终止向您提供服务，因您上述行为给e企测造成损失的，您应予赔偿。<br>
            <p style="font-size:18px;weight:bold">六、e企测的权利和义务</p>
            (一) e企测应根据您选择的服务以及交纳款项的情况向您提供合格的企业体系咨询认证和资质认证。<br>
            (二) e企测承诺对您资料采取对外保密措施，不向第三方披露您资料，不授权第三方使用您资料，除非：<br>
            依据本协议条款或者您与e企测之间其他服务协议、合同等规定可以提供；<br>
            依据法律法规的规定应当提供；<br>
            行政、司法等职权部门要求e企测提供；<br>
            您同意e企测向第三方提供；<br>
            e企测解决举报事件、提起诉讼而提交的；<br>
            e企测为防止严重违法行为或涉嫌犯罪行为发生而采取必要合理行动所必须提交的；<br>
            网为向您提供产品、服务、信息而向第三方提供的，包括e企测通过第三方向您提供产品、服务、咨询。<br>
            (三) e企测及e企测关联公司所有网站有权使用您的资料和信息。<br>
            (四) e企测保留在您违反国家、地方法律法规规定或违反本在线注册条款的情况下终止为您提供服务并终止您帐号的权利。<br>
            <p style="font-size:18px;weight:bold">七、隐私及其他个人信息的保护</p>
            一旦您同意本协议或使用本服务，您即同意本公司按照以下条款来使用和披露您的个人信息。<br>
            (一)注册信息<br>
            您注册该账户时应向本公司提供您的真实姓名、地址、电话号码和电子邮件地址，您还可以选择来填写相关附加信息（包括但不限于您公司所在的省份和城市、和邮政编码、传真号码、网址和您的职务）。为有针对性地向您提供新的服务和机会，您了解并同意本公司及其关联公司或您登录的其他网站将通过您的电子邮件地址或该手机通知您这些信息。<br>
            (二)手机信息<br>
            您应保护好您的手机，一旦您手机出借、被盗、遗失或被他人窥视等，均可能引起您e企测账户相关个人信息之外泄，e企测对此不承担任何责任。<br>
            (三)银行账户信息<br>
            若本公司所提供的服务需要您提供您的银行账户信息，在您提供相应信息后，本公司将严格履行相关保密约定。<br>
            (四)登录记录<br>
            为了保障您使用本服务的安全以及不断改进服务质量，本公司将记录并保存您登录和使用本服务的相关信息，但本公司承诺不将此类信息提供给任何第三方（除双方另有约定或法律法规另有规定及本公司关联公司外）。<br>
            (五)广告<br>
            本公司会对e企测用户的身份数据进行综合统计，并出于销售和奖励的需要使用或披露。<br>
            (六)外部链接<br>
            本网站含有到其他网站的链接，但本公司对其他网站的隐私保护措施不负任何责任。本公司可能在任何需要的时候增加商业伙伴或共用品牌的网站。<br>
            <p style="font-size:18px;weight:bold">八、系统中断或故障</p>
            系统因下列状况无法正常运作，使您无法使用各项服务时，本公司不承担损害赔偿责任，该状况包括但不限于：<br>
            (一)本公司在本网站公告之系统停机维护期间。<br>
            (二)电信设备出现故障不能进行数据传输的。<br>
            (三)因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成本公司系统障碍不能执行业务的。
            您应保护好您的手机，一旦您手机出借、被盗、遗失或被他人窥视等，均可能引起您e企测账户相关个人信息之外泄，e企测对此不承担任何责任。<br>
            (四)由于黑客攻击、电信部门技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或者延迟。<br>
            <p style="font-size:18px;weight:bold">九、责任范围及责任限制</p>
            (一)本公司仅对本协议中列明的责任承担范围负责。<br>
            (二) e企测用户信息是由您本人自行提供的，本公司无法保证该信息之准确、及时和完整，您应对您的判断承担全部责任。<br>
            (三)您自本公司及本公司工作人员或经由本服务取得之建议和资讯，无论其为书面或口头形式，均不构成本公司对本服务之保证。<br>
            (四)在法律允许的情况下，本公司对于与本协议有关或由本协议引起的任何间接的、惩罚性的、特殊的、派生的损失（包括业务损失、收益损失、利润损失、使用数据或其他经济利益的损失），不论是如何产生的，也不论是由对本协议的违约（包括违反保证）还是由侵权造成的，均不负有任何责任，即使事先已被告知此等损失的可能性。另外即使本协议规定的排他性救济没有达到其基本目的，也应排除本公司对上述损失的责任。<br>
            (五)除本协议另有规定外，在任何情况下，本公司对本协议所承担的违约赔偿责任总额不超过向您收取的当次代理服务费用的总额。<br>
            <p style="font-size:18px;weight:bold">十、完整协议</p>
            本协议由本协议条款与本网站公示的各项规则组成，相关名词可互相引用参照，如有不同理解，以本协议条款为准。
            您对本协议理解和认同，您即对本协议所有组成部分的内容理解并认同，一旦您使用本服务，您和本公司即受本协议所有组成部分的约束。<br>
            本协议部分内容被有管辖权的法院认定为违法的，不因此影响其他内容的效力。<br>
            <p style="font-size:18px;weight:bold">十一、商标、知识产权的保护</p>
            (一)本网站上所有内容，包括但不限于著作、图片、档案、资讯、资料、网站架构、网站画面的安排、网页设计，均由本公司或本公司关联企业依法拥有其知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。<br>
            (二)非经本公司或本公司关联企业书面同意，任何人不得擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表本网站程序或内容。<br>
            (三)尊重知识产权是您应尽的义务，如有违反，您应承担损害赔偿责任。<br>
            <p style="font-size:18px;weight:bold">十二、法律适用与管辖</p>
            本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本协议产生之争议，均应依照中华人民共和国法律予以处理，并提交杭州市滨江区人民法院审判。
          </a-modal>
          <!-- 账号 -->
          <a-form-item class="marginBottom">
            <a-input :maxLength="11"
              v-decorator="['phone',{ rules: [{validator:check }] },]"
              placeholder="手机号码"
            ><a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" /></a-input>
          </a-form-item>

          <!-- 图片验证码 -->
          <a-form-item class="marginBottom">
            <div class="code">
              <a-input
                v-decorator="['code',{ rules: [{ required: true, message: '请输入验证码!' }] },]"
                placeholder="验证码"
              >
                <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
              </a-input>
              <img @click="getCodeImg" style="width: 130px;height:36px;cursor:pointer;" :src="codeUrl">
            </div>
          </a-form-item>

          <!-- 短信验证码 -->
          <a-form-item class="marginBottom">
            <div class="code">
              <a-input
              v-decorator="['verificationCode',{ rules: [{ required: true, message: '请输入验证码!' }] },]"
              placeholder="短信验证码"
            >
              <a-icon slot="prefix" type="mail" style="color:rgba(0,0,0,.25)" />
            </a-input>
            <a-button type="primary" :disabled="countDownLoading" @click="getCode">{{countDownText}}</a-button>
            </div>
          </a-form-item>

          <!-- 新密码 -->
          <a-popover placement="rightTop" trigger="click" :visible="state.passwordLevelChecked">
            <!-- <template slot="content">
              <div :style="{ width: '240px' }" >
                <div :class="['user-register', passwordLevelClass]">强度：<span>{{ passwordLevelName }}</span></div>
                <a-progress :percent="state.percent" :showInfo="false" :strokeColor=" passwordLevelColor " />
                <div style="margin-top: 10px;">
                  <span>请至少输入 6 个字符。请不要使用容易被猜到的密码。</span>
                </div>
              </div>
            </template> -->
            <a-form-item class="marginBottom">
              <a-input
                @click="handlePasswordInputClick"
                type="password"
                v-decorator="['password',{rules: [{ required: true, message: '至少6位密码，区分大小写'}, { validator: this.handlePasswordLevel }], validateTrigger: ['change', 'blur']}]"
                placeholder="6到18位数字加字母组合密码"
              ><a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" /></a-input>
            </a-form-item>
          </a-popover>

          <!-- 确认密码 -->
          <a-form-item class="marginBottom">
            <a-input
              type="password"
              v-decorator="['restPassword',{ rules: [{ required: true, message: '密码不能为空' }, { validator: this.handlePasswordCheck }] },]"
              placeholder="确认密码"
            ><a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" /></a-input>
          </a-form-item>

          <!-- 重置密码按钮 -->
          <a-form-item style="width: 80%;margin: 50px auto 0 auto;">
            <a-button type="primary" :loading="loading" block @click="handleSubmit">{{buttonText}}</a-button>
          </a-form-item>

          <!-- 注册条款 -->
          <div class="protocol">
              <a-checkbox @change="selectChange"><a-button type="link" @click="this.info">e企测注册协议及服务条款</a-button></a-checkbox>
              <a-button type="link"><router-link to="/account/login">我已有账号，直接登录</router-link></a-button>
          </div>
          
        </a-form>
      </div>
  </div>
</template>

<script>

import {checkPhone} from '@/utils'
const levelNames = {
  0: '低',
  1: '低',
  2: '中',
  3: '强'
}
const levelClass = {
  0: 'error',
  1: 'error',
  2: 'warning',
  3: 'success'
}
const levelColor = {
  0: '#ff0000',
  1: '#ff0000',
  2: '#ff7e05',
  3: '#52c41a'
}
import { getCodeImg, sendSmsCode, register } from '@/api/account'
export default {
  props: [ 'device' ],
  data() {
    return {
      visible: false,
      form: this.$form.createForm(this),
      loading: false,
      buttonText: '同意条款并注册',
      timer: null,
      countDownText: '获取验证码', // 获取验证码按钮文本
      countDownLoading: false,
      protocolSelect: false,
      codeUrl: '', // 图形验证码
      state: {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000'
      },
    };
  },

  computed: {
    passwordLevelClass () {
      return levelClass[this.state.passwordLevel]
    },
    passwordLevelName () {
      return levelNames[this.state.passwordLevel]
    },
    passwordLevelColor () {
      return levelColor[this.state.passwordLevel]
    }
  },

  created() {
    // this.countDown()
    this.getCodeImg()
  },

  methods: {
    goHome() {
      window.location.href = "https://www.hongenwangluo.com/";
    },
    check(rule, value, callback){
      
      checkPhone(rule, value, callback)
    },
    // 密码强度验证
    handlePasswordLevel (rule, value, callback) {
      let level = 0
      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++
      }
      this.state.passwordLevel = level
      this.state.percent = level * 30
      if (level >= 2) {
        if (level >= 3) {
          this.state.percent = 100
        }
        callback()
      } else {
        if (level <= 0) {
          this.state.percent = 10
        }
        callback(new Error('密码强度不够'))
      }
    },
    // 验证密码强度提示窗
    handlePasswordInputClick () {
      this.state.passwordLevelChecked = true
      return
    },

    // 确认密码
    handlePasswordCheck (rule, value, callback) {
      const password = this.form.getFieldValue('password')
      if (value === undefined) {
        callback(new Error('请输入密码'))
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error('两次密码不一致'))
      }
      callback()
    },
    // 获取图片验证码
    async getCodeImg() {
      try {
        const data = await getCodeImg()
        this.codeUrl = `data:image/gif;base64,${data.img}`
        this.uuid = data.uuid
      } catch (error) {
        
      }
    },

    // 条款选中状态
    selectChange(e) {
      this.protocolSelect = e.target.checked
    },

    // 倒计时
    countDown() {
      let that = this
      try {
        let sendCode = that.$pub.getCookie('reset_time')

        // let sendCode = null
        if(sendCode) {
          that.countDownLoading = true
          let count = parseInt(sendCode)
          
          var timer = setInterval(() => {
            // that.$cookies.set('reset_time', count, {expires: 0.5})
            count--
            // console.log(count);
            that.countDownText = `剩余${count}秒`
            if(count == 0) {
              that.countDownText = '获取验证码'
              that.countDownLoading = false
              // that.$cookies.remove('reset_time')
              // clearInterval(this.timer)
              that.timer = null
              clearInterval(timer);
              // that.$cookies.set('reset_time', null, {expires: 0.5})
            }
          }, 1000);
        }
      } catch (error) {
        console.log(error)
      }
    },

    // 获取验证码
    async getCode() {
      let that = this
      try {
        that.$cookies.set('reset_time', 60, {expires: 0.5})
        let params = {
          scope:'register',
          phoneNumber: this.form.getFieldValue('phone'),
          code: this.form.getFieldValue('code'),
          uuid: this.uuid
        }
        this.form.validateFields(['phone','code'])
        // return false
        let data = await sendSmsCode(params)
        that.countDown()
      } catch (error) {
        console.log(error)
      }
    },

    // 注册条款
    info() {
      this.visible = true
    },
    handleCancel(){
      this.visible = false
    },

    setBtnStatus(status, text) {
      this.loading = status
      this.buttonText = text
    },
    handleSubmit() {
      let that = this
        if(!this.protocolSelect) {
          return this.$message.error('您必须同意e企测注册协议及服务条款')
        }
        that.setBtnStatus(true, '正在提交')
        that.form.validateFields( async (err, params) => {
          if(!err) {
             register(params).then(res => {
                that.$message.success('注册成功')
                setTimeout(() => {
                  that.setBtnStatus(false, '同意条款并注册')
                  that.$router.push('/')
                }, 1000);
             }).catch(error => {
               that.setBtnStatus(false, '同意条款并注册')
                console.log("error",error)
             })
            
          } else {
            that.setBtnStatus(false, '同意条款并注册')
          }
        })
    }
  }
};
</script>

<style lang="less" scoped>
.marginBottom{
    margin-bottom: 15px !important;
    width: 80%;
    margin: 0 auto;
    border-bottom: 1px solid #c2c2c2;
    .ant-btn {height: 40px;}
}
.rule-layer {

  // .ant-modal {
  //     height: 80%;
  // }
}
.register {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  &.mobile {
    .description, .title, .form { width: 95%;}
  }
  .register-left {
    width: 60%;
    height: 100%;
    background: url('../../assets/images/login-bg.png') center no-repeat;
    background-size: 100% 100%;
  }
  .register-right {
      width: 40%;
      height: 100%;
      padding: 150px 100px;
      .logo {
        width: 157px;
        height: 111px;
        margin: 20px auto;
        img {
          width: 100%;
          height: 100%;
        }
      }
    .form {
      width: 100%;
      background: #fff;
      padding: 15px 30px;

      .ant-btn {height: 53px;}
      /deep/.ant-input {
        height: 60px;
        line-height: 60px;
        border: none ;
        outline: none;
        box-shadow: none;
      }
      .protocol {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;
        width: 80%;
        margin: 0 auto;
        .ant-checkbox-wrapper {display: flex;align-items: center;}
        /deep/.ant-btn {padding: 0 !important;}
      }
      .code {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .ant-btn {height: 40px;}
        /deep/.ant-input {width: calc(100% - 5px);}
      }
    }
  }
}
@media only screen and (max-width: 414px){
  .register {
    .register-left {
      display: none;
    }
    .register-right {
      width: 100%;
      padding: 0;
      .form {
        .ant-btn {height: 30px;}
        /deep/.ant-input {
          height: 30px;
          line-height: 30px;
          border: none ;
          outline: none;
          box-shadow: none;
        }
        .protocol {
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          .ant-checkbox-wrapper {
            width: 100%;
            text-align: center;
            display: flex;
            justify-content: center;
          }
          .ant-btn {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
